import React from 'react';
import {
  Box,
  Container,
  Heading,
  VStack,
  HStack,
  Image,
  Text,
  IconButton,
  useColorMode,
  Divider,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { FiPlay, FiHeart, FiMoreVertical } from 'react-icons/fi';

const MotionBox = motion(Box);

const CategorySongs = () => {
  const { colorMode } = useColorMode();
  const { id } = useParams();

  // Mock data for category songs
  const songs = [
    {
      id: 1,
      title: 'آهنگ ۱',
      artist: 'هنرمند ۱',
      duration: '3:45',
      cover: 'https://picsum.photos/200',
    },
    {
      id: 2,
      title: 'آهنگ ۲',
      artist: 'هنرمند ۲',
      duration: '4:20',
      cover: 'https://picsum.photos/201',
    },
    {
      id: 3,
      title: 'آهنگ ۳',
      artist: 'هنرمند ۳',
      duration: '3:15',
      cover: 'https://picsum.photos/202',
    },
    {
      id: 4,
      title: 'آهنگ ۴',
      artist: 'هنرمند ۴',
      duration: '5:10',
      cover: 'https://picsum.photos/203',
    },
  ];

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Heading size="xl">آهنگ‌های دسته‌بندی {id}</Heading>
        <Box
          bg={colorMode === 'dark' ? 'gray.700' : 'white'}
          borderRadius="xl"
          overflow="hidden"
          boxShadow="lg"
        >
          {songs.map((song, index) => (
            <MotionBox
              key={song.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <HStack
                p={4}
                spacing={4}
                _hover={{ bg: colorMode === 'dark' ? 'gray.600' : 'gray.50' }}
                cursor="pointer"
              >
                <Image
                  src={song.cover}
                  alt={song.title}
                  boxSize="50px"
                  borderRadius="md"
                />
                <Box flex="1">
                  <Text fontWeight="bold">{song.title}</Text>
                  <Text fontSize="sm" color="gray.500">
                    {song.artist}
                  </Text>
                </Box>
                <Text color="gray.500">{song.duration}</Text>
                <HStack spacing={2}>
                  <IconButton
                    icon={<FiHeart />}
                    variant="ghost"
                    colorScheme="red"
                    aria-label="Add to favorites"
                  />
                  <IconButton
                    icon={<FiPlay />}
                    variant="ghost"
                    colorScheme="brand"
                    aria-label="Play"
                  />
                  <IconButton
                    icon={<FiMoreVertical />}
                    variant="ghost"
                    aria-label="More options"
                  />
                </HStack>
              </HStack>
              {index < songs.length - 1 && <Divider />}
            </MotionBox>
          ))}
        </Box>
      </VStack>
    </Container>
  );
};

export default CategorySongs; 